import { DRC_REASON_CODES, END_USER_STATUSES, IR35_STATUSES } from '../types/drc';

/** Headline for the status chip, and the label each blocker gets in the "what to fix next" list. */
export const DRC_REASON_LABELS: Record<DRC_REASON_CODES, string> = {
  [DRC_REASON_CODES.NO_PROFILE]: 'Nothing set up for this worker yet',
  [DRC_REASON_CODES.NOT_VAT_REGISTERED]: 'Not VAT registered',
  [DRC_REASON_CODES.VAT_NOT_VERIFIED]: 'VAT number not verified with HMRC',
  [DRC_REASON_CODES.NOT_CIS]: 'Not marked as working within construction',
  [DRC_REASON_CODES.END_USER]: 'Ruled an end user — the charge cannot apply',
  [DRC_REASON_CODES.END_USER_NOT_CONFIRMED]: 'End-user status not assessed',
  [DRC_REASON_CODES.NO_EFFECTIVE_DATE]: 'No start date set',
  [DRC_REASON_CODES.NOT_YET_EFFECTIVE]: 'Starts later',
  [DRC_REASON_CODES.ENDED]: 'The period has closed',
};

export const END_USER_OPTIONS: {
  value: END_USER_STATUSES;
  label: string;
  hint: string;
  /** The one value that makes DRC eligible — the control marks it out. */
  eligible?: boolean;
}[] = [
  {
    value: END_USER_STATUSES.NOT_ASSESSED,
    label: 'Not assessed',
    hint: 'No decision recorded yet',
  },
  {
    value: END_USER_STATUSES.END_USER,
    label: 'End user / intermediary',
    hint: 'DRC does not apply to this engagement',
  },
  {
    value: END_USER_STATUSES.NOT_END_USER,
    label: 'Not an end user',
    hint: 'Confirmed — makes DRC eligible',
    eligible: true,
  },
];

export const IR35_OPTIONS: { value: IR35_STATUSES; label: string; hint: string }[] = [
  {
    value: IR35_STATUSES.NOT_ASSESSED,
    label: 'Not assessed',
    hint: 'No CEST result recorded',
  },
  {
    value: IR35_STATUSES.OUTSIDE,
    label: 'Outside IR35',
    hint: 'Self-employed for tax purposes',
  },
  {
    value: IR35_STATUSES.INSIDE,
    label: 'Inside IR35',
    hint: 'Employed for tax purposes — payroll required',
  },
];

export const DRC_APPLIES_EXPLANATION =
  'On qualifying pay runs, VAT is shown but withheld from pay. V Pay Tech accounts for it to ' +
  'HMRC as customer under the reverse charge (VAT Act 1994 s55A).';

export const DRC_EFFECTIVE_FROM_HINT =
  'Applies to pay runs on or after this date. Earlier runs are unchanged.';

export const CEST_GUIDANCE_URL = 'https://www.gov.uk/guidance/check-employment-status-for-tax';

/** Uploads to the document store are public-read, as every document upload on the platform is. */
export const CEST_UPLOAD_HINT =
  'Upload the CEST result PDF. The link is unlisted rather than protected — anyone with it can open the file.';

/** The gateway rejects anything longer, or not https, with a 422. */
export const CEST_DOCUMENT_URL_MAX_LENGTH = 512;
